'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { useInstallmentCalculatorTracking } from '../../components/Tracking/hooks/useInstallmentCalculatorTracking/useInstallmentCalculatorTracking';

export interface InstallmentValueTileProps {
  /**
   * the installment value to display
   */
  value: number;
  /**
   * should the tile styled as an active one
   */
  active: boolean;
  /**
   * on click handler function
   */
  onClickHandler: (value: number) => void;
}

/**
 * installment value tile
 *
 * displays a single installment value
 *
 * */
export const InstallmentValueTile = ({
  value,
  active,
  onClickHandler,
}: InstallmentValueTileProps) => {
  const { trackInstallmentValueTileClick } = useInstallmentCalculatorTracking();

  return (
    <Button
      className="flex size-5.5 items-center justify-center"
      color={active ? 'primary' : undefined}
      onClick={() => {
        trackInstallmentValueTileClick(value);
        if (!active) {
          onClickHandler(value);
        }
      }}
    >
      <span className="text-size-body1 break-normal">{value}</span>
    </Button>
  );
};
